import React from "react";

import "./HomePage.style.scss";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";


export default function AboutPage() {
  return (
    <>
      <NavBar />
      <div className='home-page'>
        <div className='home-content'>
          <h1>Hello, I'm Justin</h1>

          <p>
            I’m a software engineer who enjoys building clean, reliable systems — mostly backend,
            distributed services, and full-stack tools that make real users' lives easier.
          </p>

          <p>
            Over the last few years, I’ve contributed to blockchain infrastructure, indexing pipelines,
            dashboards, and new SaaS products. I like solving practical problems, removing friction,
            and shipping things that actually work.
          </p>

          <p>
            These days, I’m focused on writing better software, learning from great engineers, and
            building products that feel simple on the outside — even if the backend is anything but.
          </p>

          <p>
            If you ever want to collaborate or just chat about an idea, don’t be shy —{' '}
            <a href='mailto:nuggetnchill@gmail.com' target='_blank' rel='noopener noreferrer'>say hello</a>.
          </p>

          <p className='tech-line'>
            Currently coding with: Golang · Typescript · React · PostgreSQL
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}
